
export type GetTweets200PageAllOfThreeContentItemReferencedTweetType = typeof GetTweets200PageAllOfThreeContentItemReferencedTweetType[keyof typeof GetTweets200PageAllOfThreeContentItemReferencedTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweets200PageAllOfThreeContentItemReferencedTweetType = {
  REPLIED_TO: 'REPLIED_TO',
  QUOTED: 'QUOTED',
  RETWEETED: 'RETWEETED',
} as const;
